import React from "react";
import PropTypes from "prop-types";

import globalStyles from "globalStyles";
import { Accordion, Section } from "components";
import experiences from "../../data/experiences";
import {
  K_COLORS_LIGHT_BLUE,
  K_COLORS_DARK_GREY,
  K_COLORS_DARK_NAVY,
  K_MOBILE_SIZE,
} from "constants.js";
import { useWindowSize } from "hooks";

const ExperiencesSection = (props) => {
  const { anchorRef } = props;
  const { width } = useWindowSize();

  const styles = {
    ...pcStyles,
    ...(width < K_MOBILE_SIZE ? mobileStyles : {}),
  };

  return (
    <Section style={styles.section} anchorRef={anchorRef}>
      <h1 style={styles.title}>EXPERIENCES</h1>

      <Accordion
        primaryColor={K_COLORS_LIGHT_BLUE}
        secondaryColor={K_COLORS_DARK_GREY}
        fillColor={K_COLORS_DARK_NAVY}
        items={experiences.filter(exp => exp.onDisplay)}
      />
    </Section>
  );
};

const pcStyles = {
  section: {
    ...globalStyles.fullHeightSection,
    ...globalStyles.darkBackground,
  },
  title: {
    ...globalStyles.textTitleSize,
    ...globalStyles.textLightGreyColor,
    ...globalStyles.titleSpacing,
    textAlign: "center",
    margin: "4rem",
  },
};

const mobileStyles = {
  section: {
    ...globalStyles.fullHeightSection,
    ...globalStyles.darkBackground,
    paddingTop: "4rem",
    paddingBottom: "4rem",
  },
  title: {
    ...globalStyles.textSmallSize,
    ...globalStyles.textLightGreyColor,
    ...globalStyles.titleSpacing,
    textAlign: "center",
    margin: "2rem",
  },
};

ExperiencesSection.propTypes = {
  anchorRef: PropTypes.shape().isRequired,
};

export default ExperiencesSection;
